import React from 'react';
import { Text, View } from 'react-native';

import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './CustomDay.styles';

class CustomDay {
  getPeriodType() {
    return this.marking.customStyles.period.start
      ? 'start'
      : this.marking.customStyles.period.end
        ? 'end'
        : undefined;
  }

  isCustomDay() {
    return this.isCustom() && this.marking.customStyles && this.marking.customStyles.text;
  }

  isPeriodPoint() {
    return (
      this.isCustomDay() &&
      this.marking.customStyles.period &&
      (this.marking.customStyles.period.start || this.marking.customStyles.period.end)
    );
  }

  renderText() {
    const { theme } = this.props;

    return this.isCustomDay() ? (
      <View style={styles.periodContainer}>
        {this.isPeriodPoint() && <View style={styles.periodPoint(theme, this.getPeriodType())} />}

        <View style={styles.periodCircle(theme)} />

        <Text allowFontScaling={false} style={this.getTextStyle()}>
          {String(this.props.children)}
        </Text>
      </View>
    ) : (
      super.renderText()
    );
  }
}

CustomDay.defaultProps = {
  theme: LightThemeColors,
};

export default withTheme(CustomDay);
